<template>
  <v-card
    v-if="lobby"
    elevation="3"
  >
    <v-card-title class="d-flex justify-space-between align-start mb-0 pb-3">
      <div>
        <h2>Lobby details</h2>
        <v-breadcrumbs
          class="mb-0 pb-0 ml-0 pl-0 pt-1"
          :items="breadcrumbs"
        />
      </div>
    </v-card-title>
    <v-card-text>
      {{ false ? lobby : '' }}
      <v-row>
        <v-col cols="12">
          <h3>Main info</h3>
          <table class="info-user-tbl">
            <tr>
              <td>Lobby ID</td>
              <td>{{ lobby.id }}</td>
            </tr>
            <tr>
              <td>Lobby status</td>
              <td>
                <LobbiesStatus
                  :value="parseInt(lobby.status)"
                />
              </td>
            </tr>
            <tr>
              <td>Slots</td>
              <td>{{ lobby.slots }}</td>
            </tr>
            <tr>
              <td>Creation time</td>
              <td>{{ lobby.creation_ts }}</td>
            </tr>
            <tr>
              <td>Order type</td>
              <td>
                Premade lobby
              </td>
            </tr>
          </table>
        </v-col>
      </v-row>
      <v-row class="mt-4">
        <v-col cols="12">
          <h3>Game info</h3>
          <table class="info-user-tbl">
            <tr>
              <td>Game</td>
              <td>Warzone</td>
            </tr>
          </table>
        </v-col>
      </v-row>
      <v-row class="mt-4">
        <v-col cols="12">
          <h3>Billing info</h3>
          <table class="info-user-tbl mt-3">
            <tr>
              <td>Hourly price</td>
              <td>${{ lobby.price_per_hour }}</td>
            </tr>
            <tr>
              <td>Current billing</td>
              <td>TODO</td>
            </tr>
            <tr>
              <td>Next billing</td>
              <td>TODO</td>
            </tr>
            <tr>
              <td>Your comission</td>
              <td>TODO</td>
            </tr>
            <tr>
              <td>TIPS</td>
              <td>TODO</td>
            </tr>
          </table>
        </v-col>
      </v-row>
      <v-row
        class="mt-3"
        style="max-width: 650px"
      >
        <v-col cols="12">
          <v-text-field
            v-model="lobby.description"
            label="Description (optional)"
            hide-details
            outline
            outlined
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="lobby.stream_link"
            label="Stream link"
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="12">
          <v-switch
            v-model="lobby.stream"
            disabled
            class="add-lobby-form__toggle"
            label="Stream publicly"
            hide-details
          />
        </v-col>

        <v-col cols="12">
          <v-switch
            v-model="lobby.private"
            class="add-lobby-form__toggle"
            label="Private lobby (invite only)"
            hide-details
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="lobby.invite_link"
            label="Invite link for clients"
            hide-details
            outlined
            append-icon="mdi-content-copy"
            @keydown="(e) => e.preventDefault()"
            @click:append="copyInviteLink(lobby.invite_link)"
          />
        </v-col>
      </v-row>
      <v-row class="mt-4">
        <v-col>
          <h3>Players</h3>
          <div class="players-list">
            <div
              v-for="item in lobby.players"
              :key="item.id"
              class="players-item"
            >
              <div class="players-item__avatar">
                <img
                  src="https://api.zeyplay.com/uploads/avatar/202096458680369152_8f2e44fd2989b141a6f28c8740af2ebf.png"
                  alt=""
                >
                <span class="players-item__badge">
                  YOU
                </span>
              </div>
              <div class="players-item__content">
                <div class="players-item__name">
                  Username
                </div>
                <div class="players-item__kd">
                  <i class="icon-kd" />KD 1.4
                </div>
                <div class="players-item__lang-list">
                  <span class="lang">RU</span>
                  <span class="lang">EN</span>
                  <span class="country">
                    <img
                      src="/img/flags/ru.svg"
                      class="country__flag"
                      alt=""
                    >
                    RUSIAN
                  </span>
                </div>
                <div class="players-item__platforms">
                  <span><i class="icon-playstation" /></span>
                  <span><i class="icon-pc" /></span>
                  <span><i class="icon-xbox" /></span>
                </div>
                <div class="players-item__discord">
                  Discord:
                  <a
                    href="#"
                    target="_blank"
                  >#discordusername</a>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import lobbiesAPI from '../../api/lobbies';
import LobbiesStatus from '../../components/app/statuses/LobbiesStatus.vue';

export default {
  components: {
    LobbiesStatus,
  },
  data: () => ({
    loading: {
      init: false,
    },

    lobby: null,

    breadcrumbs: [
      { text: 'Lobbies list', to: '/lobbies/current' },
      { text: 'Details', disabled: true },
    ],
  }),

  computed: {

  },

  async created() {
    await this.getDetails();
  },

  methods: {

    getDetails() {
      const { id } = this.$route.params;
      return lobbiesAPI.get(id)
        .then((response) => {
          if (response.data.success) {
            this.lobby = response.data.data.lobby;
          }
        })
        .finally(() => {
          this.loading.init = false;
        });
    },

    copyInviteLink(text) {
      this.$toast.success('Invite link was been copied!');

      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        document.execCommand('copy') ? res() : rej();
        textArea.remove();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  color: #000;
  margin-bottom: 5px;
}

.player-name {
  margin-left: 20px;

  h1 {
    color: #000;
    margin-bottom: 5px;
  }

  span {
    font-size: 18px;
  }
}

.info-user-tbl {
  td {
    padding: 5px 0;
    font-size: 16px;

    &:first-child {
      font-weight: bold;
      padding-right: 20px;
    }
  }
}

.team-list {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.team-item {
  min-width: 180px;
  padding: 10px;
  background: rgb(243, 243, 243);
  margin-right: 20px;
  margin-bottom: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

  &__avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: rgb(97, 97, 97);
    margin-right: 10px;

    .icon {
      font-size: 24px;
      position: relative;
      top: 3px;
      color: #9c9c9c;
      opacity: 0.7;
    }

    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  .coach {
    &__name {
      font-weight: 600;
    }

    &__kd {
      font-size: 12px;
    }

    &__is-player {
      font-size: 12px;
      background: var(--color-secondary);
      color: var(--color-white);
      display: inline;
      border-radius: 3px;
      padding: 3px 8px;
    }
  }
}

.chat-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: #f9f9f9;
}

.players-list {
  display: flex;
  margin-top: 10px;

  .players-item {
    display: flex;
    background: #212121;
    border-radius: 10px;
    padding: 15px;
    color: #fff;

    &__avatar {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 15px;

      img {
        border-radius: 50%;
        width: 48px;
        height: 48px;
      }
    }

    &__badge {
      background: var(--color-secondary);
      margin-top: 10px;
      font-size: 10px;
      font-family: var(--font-bold);
      text-transform: uppercase;
      padding: 5px 10px;
      line-height: 1;
      border-radius: 5px;
    }

		&__content {
      font-family: var(--font-bold);
		}

		&__name {
      font-size: 16px;
      font-family: var(--font-bold);
      color: var(--color-secondary);
      text-transform: uppercase;
		}

		&__kd {
      margin-top: 10px;
      text-transform: uppercase;
      font-family: var(--font-bold);
      font-size: 12px;

      i {
        margin-right: 5px;
      }
		}

		&__lang-list {
      display: flex;
      align-content: center;
      margin-top: 5px;

      .lang {
        background: #000;
        margin-right: 3px;
        font-family: var(--font-bold);
        font-size: 12px;
        border-radius: 5px;
        padding: 0px 5px;
      }

      .country {
        margin-left: 5px;
        font-family: var(--font-bold);
        font-size: 12px;

        img {
          position: relative;
          top: -1px;
          width: 16px;
        }
      }
		}

		&__platforms {
      margin-top: 5px;

      i {
        font-size: 16px;
        margin-right: 5px;

        &.icon-playstation {
          font-size: 18px;
        }
      }
		}

		&__discord {

		}
}

}

</style>
